import axios from 'axios';
import { Auth } from 'aws-amplify';

export const WEB_API = 'https://md4ups5iql.execute-api.ap-northeast-2.amazonaws.com/latest';
// export const WEB_API = 'http://localhost:3000';

export const TOPBAR_HEIGHT = 85;
export const FOOTER_HEIGHT = 50;
export const CONTAINER_HEIGHT = TOPBAR_HEIGHT + FOOTER_HEIGHT;

export const readFile = (file, limit) => {
  if (!limit) limit = 5;
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = (_read) => {
      if (limit > 0 && _read.total > 1000000 * limit) {
        reject(`File too large : limit ${limit}MB`);
      } else {
        resolve(_read);
      }
    };
  });
};

const axiosInstance = axios.create({
  baseURL: WEB_API,
  timeout: 3000 * 10,
  headers: { Pragma: 'no-cache', Authorization: `${sessionStorage.getItem('_in_jwt')}` },
});

axiosInstance.interceptors.request.use(
  function (config) {
    // 요청 바로 직전 axios 설정값에 대해 작성합니다.
    config.headers.Authorization = `${sessionStorage.getItem('_in_jwt')}`;
    return config;
  },
  function (error) {
    // 요청 에러 처리를 작성합니다.
    console.log(error.message);
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  function (response) {
    // tokenRefresh().then((r) => {});
    return response;
  },

  function (error) {
    if (error.response) {
      // 요청이 이루어졌으며 서버가 2xx의 범위를 벗어나는 상태 코드로 응답했습니다.
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // 요청이 이루어 졌으나 응답을 받지 못했습니다.
      // `error.request`는 브라우저의 XMLHttpRequest 인스턴스 또는
      // Node.js의 http.ClientRequest 인스턴스입니다.
      console.log(error.request);
    } else {
      // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
      console.log('Error', error.message);
    }
    console.log(error.config);
    const orgRequest = error.config;
    if (error.response && error.response.status === 401) {
      console.log('토큰 만료');
      tokenRefresh()
        .then((refreshRes) => {
          // orgRequest.headers['Authorization'] = sessionStorage.getItem('_in_jwt');
          window.location.reload();
          // return Promise.resolve(axios(orgRequest));
        })
        .catch((err) => {
          window.location.href = '/#/signin';
        });
    }
    return Promise.reject(error);
  },
);

export const tokenRefresh = async () => {
  try {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    // console.log(cognitoUser);
    const currentSession = await Auth.currentSession();
    cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
      if (session) {
        const { accessToken } = session;
        sessionStorage.setItem('_in_jwt', accessToken.jwtToken);
        return Promise.resolve(accessToken.jwtToken);
      } else {
        console.log(err.message);
      }
    });
  } catch (e) {
    console.log('Unable to refresh Token', e);
  }
};

export default axiosInstance;
